import { nativeMobilePlatform } from "@/platform/nativeBridge";
import { useOnlineStatus } from "@/offline";
import { Banner } from "@/shared/ui";

/** Shown on Android and iOS while the device has no connection. */
export function NativeOfflineNotice() {
  const mobileOs = nativeMobilePlatform();
  const online = useOnlineStatus();
  if (!mobileOs || online) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[90] px-3 pt-[max(0.5rem,env(safe-area-inset-top))]">
      <Banner tone="warning" title="Mất kết nối mạng" />
    </div>
  );
}
